'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = require('../../../packages/common-utilities/src/constants.js');

var _constants2 = _interopRequireDefault(_constants);

var _fees_card = require('./fees_card.js');

var _fees_card2 = _interopRequireDefault(_fees_card);

var _performance_card = require('./performance_card.js');

var _performance_card2 = _interopRequireDefault(_performance_card);

var _performance_chart_parent = require('./performance_chart_parent.js');

var _performance_chart_parent2 = _interopRequireDefault(_performance_chart_parent);

var _daily_performance_chart_parent = require('./daily_performance_chart_parent.js');

var _daily_performance_chart_parent2 = _interopRequireDefault(_daily_performance_chart_parent);

var _premium_discount_chart_parent = require('./premium_discount_chart_parent.js');

var _premium_discount_chart_parent2 = _interopRequireDefault(_premium_discount_chart_parent);

var _commentary_card = require('./commentary_card.js');

var _commentary_card2 = _interopRequireDefault(_commentary_card);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _currency_utility = require('../../../packages/common-utilities/src/currency_utility.js');

var _currency_utility2 = _interopRequireDefault(_currency_utility);

var _location_service = require('../services/location_service');

var _location_service2 = _interopRequireDefault(_location_service);

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

var _collection_utility = require('common-utilities/src/collection_utility');

var _card_component = require('./global_components/card_component');

var _card_component2 = _interopRequireDefault(_card_component);

var _formatted_number = require('./global_components/formatted_number');

var _formatted_number2 = _interopRequireDefault(_formatted_number);

var _table_component = require('./global_components/table_component');

var _table_component2 = _interopRequireDefault(_table_component);

var _fund_charges = require('./fund_charges');

var _fund_charges2 = _interopRequireDefault(_fund_charges);

var _calendar_year_performance_card = require('./calendar_year_performance_card');

var _calendar_year_performance_card2 = _interopRequireDefault(_calendar_year_performance_card);

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _performance_scenarios_card = require('./performance_scenarios_card');

var _performance_scenarios_card2 = _interopRequireDefault(_performance_scenarios_card);

var _fund_utility = require('../../../packages/common-utilities/src/fund_utility');

var _chart_utility = require('../../../packages/common-utilities/src/chart_utility');

var _chart_utility2 = _interopRequireDefault(_chart_utility);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FundPerformanceFees = function (_React$Component) {
  _inherits(FundPerformanceFees, _React$Component);

  function FundPerformanceFees(props) {
    _classCallCheck(this, FundPerformanceFees);

    _location_service2.default.setTargetWindowObject(props.window);

    var _this = _possibleConstructorReturn(this, (FundPerformanceFees.__proto__ || Object.getPrototypeOf(FundPerformanceFees)).call(this, props));

    _this.currentCard = '';
    _this.togglePerformanceCard = _this.togglePerformanceCard.bind(_this);
    _this.state = {
      activeCard: 'monthEndReturns'
    };
    return _this;
  }

  _createClass(FundPerformanceFees, [{
    key: 'renderFeesCard',
    value: function renderFeesCard() {
      if (_collection_utility.CollectionUtility.intersection(this.props.fund.visibleData.visibleDataPoints, _constants2.default.getFeesConstants()).length > 0) {
        return _react2.default.createElement(_fees_card2.default, {
          fundTypeCode: this.props.fund.fundTypeCode,
          assetClass: this.props.fund.assetClass,
          expenses: this.props.fund.shareClass.expenses,
          fees: this.props.fund.shareClass.fees,
          visibleDataPoints: this.props.fund.visibleData.visibleDataPoints,
          formattingRules: this.props.fund.visibleData.formattingRules,
          breakpoint: this.props.breakpoint,
          disclosure: this.props.fund.disclosures.pdpCardFees,
          disclosures: this.props.fund.disclosures,
          secondDisclosure: this.props.country === 'us' ? this.props.fund.disclosures.pdpCardAcquiredFundFees : null,
          numberFormat: this.props.fund.numberFormat
        });
      }
    }
  }, {
    key: 'scrollToCard',
    value: function scrollToCard(cardId) {
      if ((0, _ramda.isNil)(cardId)) {
        return;
      }
      var node = this.getCardElement(cardId);
      var stickyHeaderHeight = this.getStickyHeaderOffsetHeight();

      if (node) {
        node.scrollIntoView();
        var windowYPosition = this.props.window.scrollY ? this.props.window.scrollY : this.props.window.pageYOffset;
        this.props.window.scrollTo(0, windowYPosition - stickyHeaderHeight);
        this.currentCard = cardId;
      } else {
        this.currentCard = '';
      }
    }
  }, {
    key: 'getStickyHeaderOffsetHeight',
    value: function getStickyHeaderOffsetHeight() {
      return document.querySelector(".sticky-header") ? document.querySelector(".sticky-header").offsetHeight + 30 : 290;
    }
  }, {
    key: 'getCardElement',
    value: function getCardElement(cardId) {
      return document.getElementById(cardId);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var cardParameter = _location_service2.default.getNavigateToCardParameter();
      if (!(0, _ramda.isNil)(cardParameter) && this.currentCard !== cardParameter) {
        var cardId = cardParameter === "growth-of-hypo" ? "growthOfHypotheticalInvestmentCard" : cardParameter;
        this.scrollToCard(cardId);
      }
    }
  }, {
    key: 'activeCardScrollHandler',
    value: function activeCardScrollHandler() {
      return null;
    }
  }, {
    key: 'renderRollingPeformanceChartCard',
    value: function renderRollingPeformanceChartCard() {
      return _chart_utility2.default.renderRollingPeformanceChartCard(_extends({}, this.props, { activeCardScrollHandler: this.activeCardScrollHandler }));
    }
  }, {
    key: 'getDisclosuresForBelgium',
    value: function getDisclosuresForBelgium() {
      return ["pdpCardPerformanceBelgiumUSD", "pdpCardPerformanceBelgiumGBP", "pdpCardPerformanceBelgiumCAD", "pdpCardPerformanceBelgiumCHF", "pdpCardPerformanceBelgiumAUD", "pdpCardPerformanceBelgiumCNH", "pdpCardPerformanceBelgiumHKD", "pdpCardPerformanceBelgiumHUF", "pdpCardPerformanceBelgiumJPY", "pdpCardPerformanceBelgiumNOK", "pdpCardPerformanceBelgiumNZD", "pdpCardPerformanceBelgiumPLN", "pdpCardPerformanceBelgiumSEK", "pdpCardPerformanceBelgiumSGD"];
    }
  }, {
    key: 'renderingPerformanceCard',
    value: function renderingPerformanceCard(showToggleView) {
      var _this2 = this;

      if ((0, _ramda.includes)('HIDE_PERFORMANCE_CARD', (0, _functional_utility.pathOrEmptyArray)(["visibleData", "visibleDataPoints"], this.props.fund))) {
        return null;
      }
      var disclosures = [this.props.fund.disclosures.pdpCardPerformance];
      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'CURRENCY_SPECIFIC_PERFORMANCE_DISCLOSURES')) {
        this.getDisclosuresForBelgium().map(function (item) {
          var value = _this2.props.fund.disclosures[item];
          if (!(0, _ramda.isNil)(value)) {
            disclosures.push(value);
          }
        });
      } else if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'ITALY_SPECIFIC_PERFORMANCE_INDICES_DISCLOSURES')) {
        disclosures.push(this.props.fund.disclosures.pdpCardPerformanceItaly);
      } else {
        disclosures.push(this.props.fund.disclosures.pdpCardPerformanceIndices);
      }
      disclosures = (0, _ramda.flatten)(disclosures);
      return _react2.default.createElement(_performance_card2.default, {
        country: this.props.country,
        role: this.props.role,
        shareclass: this.props.fund.shareClass,
        historicalData: this.props.historicalData,
        breakpoint: this.props.breakpoint,
        activeTab: this.props.active,
        tabOrder: this.props.fund.visibleData.visiblePerformanceCardTabs,
        disclosure: disclosures,
        largeTextDisclosure: this.props.fund.disclosures.pdpCardPerformanceLargeText,
        isShareclassMoreThanSixMonthsOld: this.props.fund.isShareclassMoreThanSixMonthsOld,
        benchmarkNames: this.props.fund.benchmarkNames,
        benchmarkTickerCodes: this.props.fund.benchmarkTickerCodes,
        visibleRegionalData: this.props.fund.visibleData.visibleRegionalDataPoint,
        visibleDataPoints: this.props.fund.visibleData.visibleDataPoints,
        visibleCharts: this.props.fund.visibleData.visibleCharts,
        formattingRules: this.props.fund.visibleData.formattingRules,
        isShareClassMoreThanAnYearOld: this.props.fund.isShareClassMoreThanAnYearOld,
        numberFormat: this.props.fund.numberFormat,
        appType: this.props.appType,
        isFlatMode: this.props.isFlatMode,
        togglePerformanceCard: this.togglePerformanceCard,
        showToggleView: showToggleView,
        fundTypeCode: this.props.fund.fundTypeCode,
        tooltip: this.props.tooltip,
        tooltipDisclosure: this.props.fund.disclosures
      });
    }
  }, {
    key: 'renderDailyPerformanceCard',
    value: function renderDailyPerformanceCard(showToggleView) {
      if (_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleCharts, "DAILY_PERFORMANCE_CARD") && _collection_utility.CollectionUtility.size(this.props.historicalData.dailyPerformanceData) > 0) {
        var fund = this.props.fund;
        var shareClass = this.props.fund.shareClass;
        return _react2.default.createElement(
          'div',
          { className: 'padding-left-0 padding-right-0' },
          _react2.default.createElement(_daily_performance_chart_parent2.default, {
            id: 'daily-performance-chart',
            gaiaRedirectUrl: this.props.gaiaRedirectUrl,
            dailyPerformanceData: this.props.historicalData.dailyPerformanceData,
            country: this.props.country,
            cusip: this.props.cusip,
            role: this.props.role,
            fundTypeCode: fund.fundTypeCode,
            breakpoint: this.props.breakpoint,
            disclosure: fund.disclosures.pdpCardDailyPerformance,
            largeTextDisclosure: fund.disclosures.pdpCardDailyPerformanceLargeText,
            tooltip: this.props.tooltip,
            visibleData: fund.visibleData,
            numberFormat: fund.numberFormat,
            shortName: shareClass.shortName,
            fundShareclassPerformanceReturn: shareClass.fundShareclassPerformanceReturn,
            togglePerformanceCard: this.togglePerformanceCard,
            showToggleView: showToggleView,
            intl: this.props.intl
          })
        );
      } else {
        return null;
      }
    }
  }, {
    key: 'togglePerformanceCard',
    value: function togglePerformanceCard(card) {
      this.setState({
        activeCard: card
      });
    }
  }, {
    key: 'showFundChargesCard',
    value: function showFundChargesCard() {
      return _react2.default.createElement(_fund_charges2.default, {
        disclosures: this.props.fund.disclosures,
        currencyCode: this.props.fund.shareClass.currencyCode,
        fees: this.props.fund.shareClass.fees,
        investmentLimitAmount: this.props.fund.shareClass.minimumInvestments.investmentLimitAmount,
        visibleData: this.props.fund.visibleData
      });
    }
  }, {
    key: 'renderCalendarYearPerformanceCard',
    value: function renderCalendarYearPerformanceCard() {
      var yearsSinceInception = _date_formatter2.default.getCalendarYearsSinceInception(this.props.fund.shareClass.shareClassInceptionDate);
      var pdpCardPerformancePriipsPastPerformanceBoldText = this.props.fund.disclosures.pdpCardPerformancePriipsPastPerformanceBoldText ? this.props.fund.disclosures.pdpCardPerformancePriipsPastPerformanceBoldText[0] : '';
      var topOfCardDisclosure = pdpCardPerformancePriipsPastPerformanceBoldText ? pdpCardPerformancePriipsPastPerformanceBoldText.replace("[]", yearsSinceInception < 10 ? yearsSinceInception : 10) : '';
      return _react2.default.createElement(_calendar_year_performance_card2.default, {
        historicalData: this.props.historicalData,
        shareclass: this.props.fund.shareClass,
        visibleData: this.props.fund.visibleData,
        numberFormat: this.props.fund.numberFormat,
        lessThan1YrDisclosure: this.props.fund.disclosures.pdpCardPerformancePriipsUnder1Year,
        bottomOfCardDisclosure: this.props.fund.disclosures.pdpCardPerformancePriipsBoldText,
        footnoteOfCardDisclosure: this.props.fund.disclosures.pdpCardPerformancePriips,
        topOfCardDisclosure: topOfCardDisclosure,
        gaiaRedirectUrl: this.props.gaiaRedirectUrl,
        role: this.props.role
      });
    }
  }, {
    key: 'renderPerformanceScenariosCard',
    value: function renderPerformanceScenariosCard() {
      if ((0, _functional_utility.isNilOrEmpty)(this.props.historicalData.historicalPerformanceScenarios)) {
        return null;
      } else {
        return _react2.default.createElement(_performance_scenarios_card2.default, {
          shareclass: this.props.fund.shareClass,
          priipsHoldingPeriod: this.props.fund.priipsHoldingPeriod,
          historicalData: this.props.historicalData,
          intl: this.props.intl,
          disclosure: this.props.fund.disclosures.pdpCardPerformanceScenariosPriips
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var activeCard = this.state.activeCard;

      var showToggleView = _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleCharts, "DAILY_PERFORMANCE_CARD") && _collection_utility.CollectionUtility.size(this.props.historicalData.dailyPerformanceData) > 0;
      var showDividendsTable = _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.formattingRules, "MOVE_DIVIDEND_CARD_TO_PERFORMANCE") && !(0, _functional_utility.isNilOrEmpty)(this.props.annualDividendPerShare);
      return _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12 print-full-width padding-all-0' },
        this.renderRollingPeformanceChartCard(),
        activeCard === 'monthEndReturns' && this.renderingPerformanceCard(showToggleView),
        !(0, _ramda.isNil)(this.props.fund.shareClass.htmlCommentaries) && !_collection_utility.CollectionUtility.includes(_constants2.default.getExcludeRolesPDPPortfolioTab(), this.props.role) && _react2.default.createElement(
          'div',
          { 'data-testid': 'print-commentary-card', className: 'print-display', style: { "display": "none" } },
          _react2.default.createElement(_commentary_card2.default, {
            htmlCommentaries: this.props.fund.shareClass.htmlCommentaries,
            disclosures: this.props.fund.disclosures })
        ),
        !_collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'HIDE_FEES_CARD') && _react2.default.createElement(
          'div',
          { className: 'padding-left-0 padding-right-0' },
          activeCard === 'monthEndReturns' && this.renderFeesCard()
        ),
        _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'FUND_CHARGES_PERFORMANCE_TAB') && _react2.default.createElement(
          'div',
          { key: "fundChargesKey", 'data-testid': 'print-fund-charges', className: 'padding-left-0 padding-right-0' },
          this.showFundChargesCard()
        ),
        _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'CALENDAR_YEAR_PERFORMANCE_CARD') && _react2.default.createElement(
          'div',
          { key: "CalendarYearPerformanceKey", 'data-testid': 'calendar-year-performance-chart', className: 'padding-left-0 padding-right-0' },
          this.renderCalendarYearPerformanceCard()
        ),
        _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleDataPoints, 'PERFORMANCE_SCENARIOS_CARD') && _react2.default.createElement(
          'div',
          { key: "PerformanceScenariosKey", 'data-testid': 'performance-scenarios-card', className: 'padding-left-0 padding-right-0' },
          this.renderPerformanceScenariosCard()
        ),
        showDividendsTable && this.renderDividendsCard(),
        _react2.default.createElement(
          'div',
          { className: 'padding-left-0 padding-right-0' },
          activeCard === 'monthEndReturns' && _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleCharts, "PERFORMANCE") && _collection_utility.CollectionUtility.size(this.props.historicalData.performanceDataForChart) > 0 && _react2.default.createElement(_performance_chart_parent2.default, (0, _fund_utility.getHypoChartProps)(this.props))
        ),
        activeCard === 'dailyReturns' && this.renderDailyPerformanceCard(showToggleView),
        _react2.default.createElement(
          'div',
          { className: 'padding-left-0 padding-right-0' },
          _collection_utility.CollectionUtility.includes(this.props.fund.visibleData.visibleCharts, "PREMIUM_DISCOUNT") && _collection_utility.CollectionUtility.size(this.props.historicalData.historicalETFClosingPriceList) > 0 && _collection_utility.CollectionUtility.size(this.props.historicalData.premiumDiscountPeriodList) > 0 && _react2.default.createElement(_premium_discount_chart_parent2.default, {
            gaiaRedirectUrl: this.props.gaiaRedirectUrl,
            premiumDiscountPeriodList: this.props.historicalData.premiumDiscountPeriodList,
            historicalETFClosingPriceList: this.props.historicalData.historicalETFClosingPriceList,
            active: this.props.active,
            cusip: this.props.cusip,
            country: this.props.country,
            role: this.props.role,
            breakpoint: this.props.breakpoint,
            tooltip: this.props.tooltip,
            disclosures: this.props.disclosures,
            intl: this.props.intl
          })
        )
      );
    }
  }, {
    key: 'renderDividendsCard',
    value: function renderDividendsCard() {
      if ((0, _functional_utility.isDataEmpty)(this.props.annualDividendPerShare)) {
        return null;
      } else {
        return _react2.default.createElement(
          'div',
          { className: 'padding-left-0 padding-right-0' },
          _react2.default.createElement(
            _card_component2.default,
            {
              headerTitle: "Dividend history",
              headerTitleId: "dividendHistoryCard",
              headerTitleLabel: "dividend-history-card-header",
              disclosureText: null,
              placementId: null,
              breakpoint: this.props.breakpoint,
              headerLabel: null
            },
            this.generateAnnualDividendPerShareTable(this.props.annualDividendPerShare)
          )
        );
      }
    }
  }, {
    key: 'generateAnnualDividendPerShareTable',
    value: function generateAnnualDividendPerShareTable(annualDividendPerShare) {
      var _this3 = this;

      var headers = [_react2.default.createElement('td', { className: 'border-top-none' })];
      var tableData = [_react2.default.createElement(
        'td',
        { className: 'border-top-none category',
          'data-testid': 'annual-dividend-per-share-text' },
        'Total dividend per share (p)'
      )];
      var tableRow = _react2.default.createElement(
        'tr',
        { className: 'category row-divider' },
        tableData
      );
      _collection_utility.CollectionUtility.forEachIndexed(annualDividendPerShare, function (value) {
        headers.push(_react2.default.createElement(
          'td',
          { className: 'border-top-none tag',
            'data-testid': 'annual-dividend-per-share-year' },
          value.dividendYearValue
        ));
        tableData.push(_react2.default.createElement(
          'td',
          { className: 'border-top-none', 'data-testid': 'annual-dividend-per-share-value' },
          (0, _ramda.isNil)(value.annualDividendPerShareAmount) ? "-" : _react2.default.createElement(_formatted_number2.default, { value: _currency_utility2.default.formatNumberForPenceWith2DecimalPlaces(value.annualDividendPerShareAmount), numberFormat: _this3.props.numberFormat })
        ));
      });
      return _react2.default.createElement(_table_component2.default, {
        tableHeaders: headers,
        tableRows: tableRow,
        tableBodyTest: '',
        activeTab: this.props.active,
        breakpoint: this.props.breakpoint
      });
    }
  }]);

  return FundPerformanceFees;
}(_react2.default.Component);

exports.default = FundPerformanceFees;